import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireFunctionsModule } from 'angularfire2/functions';
import { firebaseConfig } from './../environments/environment.prod'
import { ImageUploadModule } from "angular2-image-upload";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrickPreviewComponent } from './components/brick-preview/brick-preview.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EventClosingComponent } from './components/event-closing/event-closing.component';
import { EventAuditComponent } from './components/event-audit/event-audit.component';
import { SharedModule } from './shared/shared.module';
import { ChangeVisibilityCategoryComponent } from './components/change-visibility-category/change-visibility-category.component';
import { ConfirmVisibilityBrickComponent } from './components/confirm-visibility-brick/confirm-visibility-brick.component';
import { ImportProductsComponent } from './components/import-products/import-products.component';
import { CopyProductsComponent } from './components/copy-products/copy-products.component';
import { ZoneAuditComponent } from './components/zone-audit/zone-audit.component';
import { AddEventProductComponent } from './components/add-event-product/add-event-product.component';
import { ProductImagePickerComponent } from './components/product-image-picker/product-image-picker.component';
import { DayClosingComponent } from './components/day-closing/day-closing.component';
import { CreateOrderEventComponent } from './components/create-order-event/create-order-event.component';
import { EventOrderComponent } from './components/event-order/event-order.component';
@NgModule({
    // Modales y componentes de las pantallas de eventos (caja, responsable,
    // cliente, cocina). Lo del delivery y del festival se retiró.
    declarations: [
        AppComponent,
        BrickPreviewComponent,
        EventClosingComponent,
        EventAuditComponent,
        ChangeVisibilityCategoryComponent,
        ConfirmVisibilityBrickComponent,
        ImportProductsComponent,
        CopyProductsComponent,
        ZoneAuditComponent,
        AddEventProductComponent,
        ProductImagePickerComponent,
        DayClosingComponent,
        CreateOrderEventComponent,
        EventOrderComponent
    ],
    entryComponents: [
        BrickPreviewComponent,
        EventClosingComponent,
        EventAuditComponent,
        ChangeVisibilityCategoryComponent,
        ConfirmVisibilityBrickComponent,
        ImportProductsComponent,
        CopyProductsComponent,
        ZoneAuditComponent,
        AddEventProductComponent,
        ProductImagePickerComponent,
        DayClosingComponent,
        CreateOrderEventComponent,
        EventOrderComponent
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot({
            mode: 'ios',
        }),
        AppRoutingModule,
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireAuthModule,
        AngularFireDatabaseModule,
        // Copia local en IndexedDB: sin conexión se sigue leyendo (bricks,
        // órdenes, eventos) y las escrituras quedan en cola hasta que vuelva
        // la señal, incluso si se recarga la pestaña. synchronizeTabs deja
        // que varias pestañas del monitor compartan esa copia en vez de que
        // solo la primera tenga modo offline.
        AngularFirestoreModule.enablePersistence({ synchronizeTabs: true }),
        AngularFireFunctionsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        ImageUploadModule.forRoot(),
        BrowserAnimationsModule,
        SharedModule,
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule { }
